import type { TranslationKey } from '@dukanti/shared';
import { useTranslation } from '@dukanti/shared';
import { Copy, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PromotionSharePanel(props: {
  readonly publicUrl: string | null;
  readonly message: string;
  readonly disabled: boolean;
  readonly onCopyUrl: () => void;
  readonly onCopyMessage: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const whatsappHref = props.publicUrl
    ? `https://wa.me/?text=${encodeURIComponent(props.message)}`
    : '#';
  return (
    <section className="border-border bg-card shadow-admin-card rounded-lg border p-4">
      <h2 className="font-display text-foreground text-xl">
        {t('admin.promotionKit.preview.whatsappTitle' as TranslationKey)}
      </h2>
      <div
        dir="ltr"
        className="bg-admin-surface-muted mt-3 rounded-lg p-3 text-start font-mono text-xs [overflow-wrap:anywhere]"
      >
        {props.publicUrl ?? t('admin.promotionKit.errors.linkUnavailable' as TranslationKey)}
      </div>
      <textarea
        readOnly
        value={props.message}
        aria-label={t('admin.promotionKit.preview.whatsappTitle' as TranslationKey)}
        className="border-input bg-input-background mt-3 min-h-28 w-full resize-none rounded-lg border p-3 text-start text-sm"
      />
      <div className="mt-3 flex flex-wrap gap-2">
        <Button type="button" variant="outline" disabled={props.disabled} onClick={props.onCopyUrl}>
          <Copy className="size-4" aria-hidden />
          {t('admin.promotionKit.actions.copyUrl' as TranslationKey)}
        </Button>
        <Button
          type="button"
          variant="outline"
          disabled={props.disabled}
          onClick={props.onCopyMessage}
        >
          <Copy className="size-4" aria-hidden />
          {t('admin.promotionKit.actions.copyMessage' as TranslationKey)}
        </Button>
        <Button asChild variant="outline">
          <a
            href={props.disabled ? undefined : whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            aria-disabled={props.disabled}
          >
            <MessageCircle className="size-4" aria-hidden />
            {t('admin.promotionKit.actions.openWhatsapp' as TranslationKey)}
          </a>
        </Button>
      </div>
    </section>
  );
}
